import * as eq from 'fp-ts/Eq';
import { constTrue } from 'fp-ts/function';
export * from 'fp-ts/Eq';
export const trivial = {
    equals: constTrue,
};
export const isEqualTo = (e) => (a) => (b) => e.equals(a, b);
/**
 * Return an Eq instance for nullable values.
 * `null` and `undefined` values are considered equal.
 */
export const nullable = (e) => ({
    equals: (a, b) => (a == null && b == null) || (a != null && b != null && e.equals(a, b)),
});
/**
 * Create an Eq instance for an object with mandatory and optional properties.
 * We intentionally require all properties to be defined to detect potential programming errors.
 */
export const strict = (a) => eq.struct(a);
//# sourceMappingURL=eq.js.map